export default "__VITE_ASSET__CQhmaMjW__"